// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5528) return "static/chunks/5528-1686e2f9b028a810.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "7bdf96d6fd77ee27" + ".js";
};